<template>
  <div id="app">
    <Header class="no-flex" />
    <router-view :auctionStarts="auctionStarts" :auction="auction" />
    <Footer class="no-flex" />
    <div
      v-if="displayAuctionAlert && liveBidCode !== null && isLoggedIn"
      class="live-bid-announcement"
    >
      <b-container>
        <b-row>
          <b-col class="text-center">
            <router-link :to="liveBidCode | carLink(auction)"
              >¡Subasta en vivo ahora! Click aquí para participar.</router-link
            >
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      auction: 488,
      auctionStarts: "2026-01-29 09:00:00",
    };
  },
  created: function () {
    // Only reconnect WebSocket if logged in AND have a valid token
    if (this.isLoggedIn && this.$store.getters.token) {
      try {
        this.$store.dispatch("reconnectWebSocket");
      } catch (error) {
        console.error('WebSocket reconnection failed:', error);
      }
    }
  },
  filters: {
    carLink: function (code, auction) {
      return "/partida/" + auction + "/" + code;
    },
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    currentView: function () {
      return this.$route.name;
    },
    displayAuctionAlert: function () {
      return this.currentView === "Cars";
    },
    liveBidCode: function () {
      return this.$store.getters.liveBidCode;
    },
  },
};
</script>

<style lang="scss">
@import "assets/scss/partial";

#app {
  min-width: 200px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  > * {
    flex: 1 0 auto;

    &.no-flex {
      flex-grow: 0;
    }
  }
}

.sidebar {
  border-left: 1px solid $gray;
}

.live-bid-announcement {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-color: $red;
  color: $white;
  font-size: 1.5rem;
  padding: 1rem 0;
  font-weight: 600;
  z-index: 100;

  a,
  a:visited,
  a:focus,
  a:hover {
    color: $white;
  }
}
</style>
